import { Box, Container, Typography } from '@mui/material';
import Image from 'next/image';
import clsx from 'clsx';

import { coFounderSectionContent } from '../constant';
import { useStyles } from './useStyles';

const CoFounderSection = () => {
  const classes = useStyles();
  return (
    <Box>
      {coFounderSectionContent.map((item) => (
        <Box key={item.id} bgcolor={item.bgColor}>
          <Container
            maxWidth="xl"
            disableGutters
            className={classes.mainContainer}
          >
            <Box className={classes.imgContainer}>
              <Image src={item.icon} alt={item.alt} layout="fill" />
            </Box>

            <Box>
              <Typography
                variant="h1"
                color={item.titleColor}
                className={classes.title}
              >
                {item.name}
              </Typography>
              <Box className={classes.tableContainer}>
                {item.description.map((content) => (
                  <Box className={classes.table}>
                    <Typography
                      variant="body1"
                      color={item.descriptionColor}
                      sx={{ fontWeight: 'bold' }}
                    >
                      {content.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      color={item.descriptionColor}
                      className={classes.title}
                    >
                      {content.content}
                    </Typography>
                  </Box>
                ))}
              </Box>
              <Box sx={{ position: 'relative' }}>
                <Typography
                  variant="body1"
                  color={item.descriptionColor}
                  maxWidth="875px"
                  className={classes.title}
                >
                  {item.thought}
                </Typography>
                <Typography
                  variant="h1"
                  color={item.descriptionColor}
                  className={classes.colon}
                >
                  ”
                </Typography>
              </Box>
            </Box>
          </Container>
        </Box>
      ))}
    </Box>
  );
};

export default CoFounderSection;
